if (!customElements.get('engraving-symbols')) {
  customElements.define('engraving-symbols',
    class EngravingSymbols extends HTMLElement {
      constructor() {
        super();         
      }
    
      connectedCallback() {
        var container = this.closest('.fieldset');
        
        this.elements = {
          input: container.querySelector('input[type="text"]'),
          triggerButton: this.previousSibling,
          symbolsWrapper: this.querySelector('.engraving-symbols'),
          symbols: this.querySelectorAll('.engraving-symbol')
        };
    
        this.setupEventListeners();
      }
    
      // Creates the event listeners
      setupEventListeners() {
        if (this.elements.triggerButton !== null) this.elements.triggerButton.addEventListener('click', this.onTriggerButtonClick.bind(this));
        if (this.elements.symbols.length > 0) {
          this.elements.symbols.forEach((symbol) => {
            symbol.addEventListener('click', this.onSymbolClick.bind(this));
          });            
        } 
      }
    
      // On clicking on the trigger button
      onTriggerButtonClick(event) {   
        event.stopImmediatePropagation();
        this.elements.symbolsWrapper.classList.toggle('hidden');
      } 
    
      // On clicking on a symbol
      onSymbolClick(event) {        
        event.stopImmediatePropagation();
        
        var symbol = event.currentTarget.textContent,
            currentEngraving = this.elements.input.value;
    
        this.elements.input.value = currentEngraving + symbol;
      }       
    }
  );
}